export default "__VITE_ASSET__mzcFE4vA__"